/* eslint-disable lines-around-comment */
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { setAudioInputDeviceAndUpdateSettings, setAudioOutputDevice as setAudioOutputDeviceAction } from '../../../../base/devices/actions.web';
import { getAudioInputDeviceData, getAudioOutputDeviceData } from '../../../../base/devices/functions.web';
// @ts-ignore
import { getCurrentMicDeviceId, getCurrentOutputDeviceId } from '../../../settings/functions.web';
import { getAudioSettingsVisibility } from '../../../../settings/functions.web';
import { toggleAudioSettings } from '../../../../settings/actions';
import { areAudioLevelsEnabled } from '../../../config/functions.web';
import DeviceStatus from '../../../../prejoin/components/web/preview/DeviceStatus';
// @ts-ignore
import { Toolbox } from '../../../../toolbox/components/web';
import { getConferenceName } from '../../../conference/functions';
import { PREMEETING_BUTTONS, THIRD_PARTY_PREJOIN_BUTTONS } from '../../../config/constants';
import { getToolbarButtons, isToolbarButtonEnabled } from '../../../config/functions.web';
import { connect } from '../../../redux/functions';
import { withPixelLineHeight } from '../../../styles/functions.web';
import ConnectionStatus from './ConnectionStatus';
// @ts-ignore
import Preview from './Preview';
// @ts-ignore
import AudioSettingsContent from '../../../../settings/components/web/audio/AudioSettingsContent';
const useStyles = makeStyles()(theme => {
    return {
        subtitle: Object.assign(Object.assign({}, withPixelLineHeight(theme.typography.heading5)), { color: theme.palette.text01, marginBottom: theme.spacing(4), overflow: 'hidden', textAlign: 'center', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' })
    };
});
const PreMeetingScreen = ({ _buttons, _premeetingBackground, _roomName, children, className, showDeviceStatus, skipPrejoinButton, title, videoMuted, videoTrack, currentMicDeviceId, currentOutputDeviceId, microphoneDevices, setAudioInputDevice, setAudioOutputDevice, outputDevices, measureAudioLevels }) => {
    const containerClassName = `premeeting-screen ${className ? className : ''}`;
    const style = _premeetingBackground ? {
        background: _premeetingBackground,
        backgroundPosition: 'center',
        backgroundSize: 'cover'
    } : {};
    return (React.createElement("div", { className: containerClassName },
        React.createElement("div", { style: style },
            React.createElement("div", { className: 'content' },
                React.createElement(ConnectionStatus, null),
                React.createElement("div", { className: 'content-controls' },
                    React.createElement("h1", { className: 'title' }, title),
                    children,
                    _buttons.length && React.createElement(Toolbox, { toolbarButtons: _buttons }),
                    skipPrejoinButton,
                    React.createElement("div", null,
                        React.createElement(AudioSettingsContent, { className2: "audio-settings-open", currentMicDeviceId: currentMicDeviceId, currentOutputDeviceId: currentOutputDeviceId, measureAudioLevels: measureAudioLevels, microphoneDevices: microphoneDevices, outputDevices: outputDevices, setAudioInputDevice: setAudioInputDevice, setAudioOutputDevice: setAudioOutputDevice })),
                    showDeviceStatus && React.createElement(DeviceStatus, null)))),
        React.createElement(Preview, { videoMuted: videoMuted, videoTrack: videoTrack })));
};
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const { hiddenPremeetingButtons, hideConferenceSubject } = state['features/base/config'];
    const toolbarButtons = getToolbarButtons(state);
    const premeetingButtons = (ownProps.thirdParty
        ? THIRD_PARTY_PREJOIN_BUTTONS
        : PREMEETING_BUTTONS).filter((b) => !(hiddenPremeetingButtons || []).includes(b));
    const { premeetingBackground } = state['features/dynamic-branding'];
    return {
        microphoneDevices: getAudioInputDeviceData(state),
        currentMicDeviceId: getCurrentMicDeviceId(state),
        currentOutputDeviceId: getCurrentOutputDeviceId(state),
        isOpen: getAudioSettingsVisibility(state),
        outputDevices: getAudioOutputDeviceData(state),
        measureAudioLevels: areAudioLevelsEnabled(state),
        // For keeping backwards compat.: if we pass an empty hiddenPremeetingButtons
        // array through external api, we have all prejoin buttons present on premeeting
        // screen regardless of passed values into toolbarButtons config overwrite.
        // If hiddenPremeetingButtons is missing, we hide the buttons according to
        // toolbarButtons config overwrite.
        _buttons: hiddenPremeetingButtons
            ? premeetingButtons
            : premeetingButtons.filter(b => isToolbarButtonEnabled(b, toolbarButtons)),
        _premeetingBackground: premeetingBackground,
        _roomName: hideConferenceSubject ? undefined : getConferenceName(state)
    };
}
const mapDispatchToProps = {
    onClose: toggleAudioSettings,
    setAudioInputDevice: setAudioInputDeviceAndUpdateSettings,
    setAudioOutputDevice: setAudioOutputDeviceAction
};
export default connect(mapStateToProps, mapDispatchToProps)(PreMeetingScreen);
